import styled from 'styled-components'

/** One paragraph of a panel's title tooltip, spaced when several are stacked. */
export const TooltipParagraph = styled.p`
  margin: 0;

  & + & {
    margin-top: 0.5rem;
  }
`
